/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Law8Inputs */

const en__field_enum_study_law8 = /** @type {(inputs: _Field_Enum_Study_Law8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Law`)
};

const de__field_enum_study_law8 = /** @type {(inputs: _Field_Enum_Study_Law8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtswissenschaft`)
};

/**
* | output |
* | --- |
* | "Law" |
*
* @param {_Field_Enum_Study_Law8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_law8 = /** @type {((inputs?: _Field_Enum_Study_Law8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Law8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_law8(inputs)
	return de__field_enum_study_law8(inputs)
});
export { _field_enum_study_law8 as "_field_enum_STUDY_LAW" }